import type { FirebaseOptions } from "firebase/app";

/**
 * Public Firebase web config. Safe to ship to the client — Firebase
 * uses Security Rules (Firestore/Storage) and App Check for protection.
 *
 * To override per environment, set VITE_FIREBASE_* in a .env.local file.
 */
export const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "AIzaSyBg7eeaumS4uAGDY2CjXUUm-ZSi2GaP-ug",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "pomilioseguros.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "pomilioseguros",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "pomilioseguros.firebasestorage.app",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "583215602978",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ?? "1:583215602978:web:8c8c00ef3e07ede0ccd97b",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? "G-HRL2R3THLL",
};
